import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { fetchTaskDependencies } from "~/store/actions/actions.taskDependencies.jsx";
import { makeGetTaskHasDependenciesSelector } from "~/store/selectors/selector.taskDependencies.jsx";
import DependenciesBodyWithItems from "./DependenciesBodyWithItems.jsx";
import DependenciesBodyWithoutItems from "./DependenciesBodyWithoutItems.jsx";

const DependenciesBodyContainer = ({ taskId, projectId, ...rest }) => {
  const dispatch = useDispatch();
  const [force, setForce] = useState(false);
  const getTaskHasDependencies = useMemo(makeGetTaskHasDependenciesSelector, []);

  const taskHasDependencies = useSelector((state) => getTaskHasDependencies(state, taskId));

  const getTaskDependencies = useCallback(() => {
    dispatch(fetchTaskDependencies(taskId));
  }, [dispatch, taskId]);

  const handleClick = useCallback(() => {
    setForce((prevState) => !prevState);
  }, []);

  useEffect(() => {
    getTaskDependencies();
  }, [getTaskDependencies]);

  return !force && !taskHasDependencies ? (
    <DependenciesBodyWithoutItems
      onClick={handleClick}
      projectId={projectId}
    />
  ) : (
    <DependenciesBodyWithItems
      {...rest}
      force={force}
      onClick={handleClick}
      onCancel={handleClick}
      taskId={taskId}
      taskHasDependencies={taskHasDependencies}
    />
  );
};

DependenciesBodyContainer.propTypes = {
  taskId: PropTypes.number,
  projectId: PropTypes.number,
};

export default DependenciesBodyContainer;
